/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Mascot_Chat_GreetingInputs */

const tr_mascot_chat_greeting = /** @type {(inputs: Mascot_Chat_GreetingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Merhaba${i?.name}! Ben Jinx, ShopPanel destek asistanın. Nasıl yardımcı olabilirim?`)
};

const en_mascot_chat_greeting = /** @type {(inputs: Mascot_Chat_GreetingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hi${i?.name}! I'm Jinx, your ShopPanel support assistant. How can I help you?`)
};

const de_mascot_chat_greeting = /** @type {(inputs: Mascot_Chat_GreetingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hallo${i?.name}! Ich bin Jinx, dein ShopPanel Support-Assistent. Wie kann ich dir helfen?`)
};

const ru_mascot_chat_greeting = /** @type {(inputs: Mascot_Chat_GreetingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Привет${i?.name}! Я Jinx, ваш помощник ShopPanel. Чем я могу помочь?`)
};

/**
* | output |
* | --- |
* | "Hi{name}! I'm Jinx, your ShopPanel support assistant. How can I help you?" |
*
* @param {Mascot_Chat_GreetingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_greeting = /** @type {((inputs: Mascot_Chat_GreetingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_GreetingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_greeting(inputs)
	if (locale === "de") return de_mascot_chat_greeting(inputs)
	if (locale === "ru") return ru_mascot_chat_greeting(inputs)
	return tr_mascot_chat_greeting(inputs)
});